import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { Observable, ReplaySubject, merge } from 'rxjs';
import { first, withLatestFrom } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { AppleDevice, Device } from '@era/locations-sdk';

import { AppleDeviceStoreSelectors, DeviceStoreActions, DeviceStoreModels, DeviceStoreSelectors } from '@era/stores';
import { DeviceLinkSelectorComponent } from '../../../components/device-link-selector/device-link-selector.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-device-assign',
  templateUrl: './device-assign.container.html',
  styleUrls: ['./device-assign.container.scss'],
  imports: [DeviceLinkSelectorComponent, RouterLink, AsyncPipe],
})
export class DeviceAssignContainerComponent {
  public readonly selectionSubject = new ReplaySubject<DeviceStoreModels.SelectedLocation>(1);
  public readonly data$: Observable<DeviceStoreModels.SelectedLocation>;
  public readonly selection$: Observable<DeviceStoreModels.SelectedLocation>;

  constructor(
    private readonly appleDeviceStore: Store<AppleDevice>,
    private readonly deviceStore: Store<Device>,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {
    this.data$ = this.deviceStore.select(DeviceStoreSelectors.selectSelectedLocation);
    this.selection$ = merge(this.data$, this.selectionSubject);
  }

  public updateSelection(selectedLocation: DeviceStoreModels.SelectedLocation) {
    this.selectionSubject.next(selectedLocation);
  }

  public assign() {
    this.appleDeviceStore
      .select(AppleDeviceStoreSelectors.selectCurrentDeviceLink)
      .pipe(withLatestFrom(this.selection$), first())
      .subscribe(([link, selection]) => {
        if (selection.roomId === undefined) {
          // Mark the device as a spare
          this.deviceStore.dispatch(
            DeviceStoreActions.DeviceAssignViewActions.deviceMarkedAsSpare({
              deviceLink: link,
              brandId: selection.brandId,
              locationId: selection.locationId,
            })
          );
        } else {
          // Assign the device to a room
          this.deviceStore.dispatch(
            DeviceStoreActions.DeviceAssignViewActions.deviceAssigned({
              deviceLink: link,
              brandId: selection.brandId,
              locationId: selection.locationId,
              roomId: selection.roomId,
            })
          );
        }
        void this.router.navigate(['../'], { relativeTo: this.route });
      });
  }
}
